import { AppKind } from "./components/SerializedApp";
import { isCustomDomain } from "./customDomains";
import { getCloudFunctionLocationForProject } from "./Support";

const stagingBuilderMeasurementID = "G-5C1TJQMXGT";
const prodBuilderMeasurementID = "G-MB6SN3XQYK";

// FIXME: We want a different configuration for the player
const prodAnalyticsMixin = {
    appId: "1:397046215911:web:0799978223eea405fa5e42",
    measurementId: "G-HP5L2HJ0QR",
};

const FirebaseConfigGlide = {
    apiKey: "AIzaSyCdlydoa5aGY9eVkZODhJFbD_lx_q7Pmks",
    authDomain: "glide-prod.firebaseapp.com",
    projectId: "glide-prod",
    databaseURL: "https://glide-prod.firebaseio.com",
    storageBucket: "glide-prod.appspot.com",

    // Builder Analytics
    appId: "1:397046215911:web:1069e1411afebe99fa5e42",
    measurementId: prodBuilderMeasurementID,

    // Keep this in sync with the corresponding service worker file
    messagingSenderId: "397046215911",
};

const stagingAnalyticsMixin = {
    appId: "1:707347437040:web:b3b838304228044726f935",
    measurementId: "G-6DZ2G0GYES",
};

const FirebaseStagingConfigGlide = {
    apiKey: "AIzaSyB2dCXFckok-ArS35WdSlsYKHkwpfQEeIo",
    authDomain: "glide-staging.firebaseapp.com",
    projectId: "glide-staging",
    databaseURL: "https://glide-staging.firebaseio.com",
    storageBucket: "glide-staging.appspot.com",

    // Builder Analytics
    appId: "1:707347437040:web:99b2cf5e6eddb7c226f935",
    measurementId: stagingBuilderMeasurementID,
    messagingSenderId: "707347437040",
};

const prodCredentials = {
    appId: "397046215911",
    developerKey: "AIzaSyDqeyCb3qU-V05e4VK4DJJjmJltSp4iAIw",
    clientId: "397046215911-aeid2ln7du7cgivjcf8ib8d4v8blvrdg.apps.googleusercontent.com",
    discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
};

const stagingCredentials = {
    appId: "707347437040",
    developerKey: "AIzaSyD_yse1U-pVdMmbuixF696cJe-u-tETfXU",
    clientId: "707347437040-v76o2du6vhja2tqja19ohv6mps5h5h0b.apps.googleusercontent.com",
    discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
};

export interface LocationSettings {
    measurementID: string;
    firebaseConfig: typeof FirebaseConfigGlide;
    serviceWorkerLocation: string;
    showBetaWarning: boolean;
    urlPrefix: string;
    stripClientKey: string;
    googleCredentials: typeof prodCredentials;
    oAuthCallbackURL: string;
    fcmKey: string;
    cloudURLPrefix: string;
    containerURLPrefix: string;
    apiURLPrefix: (hostname: string) => string;
    honeycombDatasetName: string;
    alwaysLogReloadCauses: boolean;
    useProductionTemplateIDs: boolean;
    hubspotAccountID: string;
    msalAuth: {
        // Microsoft/Excel Authentication
        tenant: string;
        clientID: string;
        scope: string;
        redirectURL: string;
    };
    isDevelopment: boolean;
    builderDbrScannerHandshake: string;
}

export interface LocationSettingsWithURL extends LocationSettings {
    // ##shortnameSuffix:
    // This should be the only place where we configure the suffix for the
    // short names, but alas, it is not.
    shortnameSuffix: string;
}

const prodApiURL = "https://api.glideapp.io";

const productionSettings: LocationSettingsWithURL = {
    measurementID: prodBuilderMeasurementID,
    firebaseConfig: FirebaseConfigGlide,
    serviceWorkerLocation: "/sw-prod-v2.js",
    showBetaWarning: false,
    shortnameSuffix: ".glideapp.io",
    urlPrefix: "https://go.glideapps.com/",
    stripClientKey: "pk_live_amBWTtPUS7d0wATlgjvx3GwV",
    googleCredentials: prodCredentials,
    oAuthCallbackURL: "https://go.glideapps.com/signInWith/google",
    fcmKey: "BLf98Y1yClC0Y3gAQ_fqx8jD75c-Ns0MZ8t3oPTbsPIz0xEsBV1ECpEY-toa0bQ5Ane7ArB-WKbWKAkmwROFxLo",
    cloudURLPrefix: getCloudFunctionLocationForProject("glide-prod"),
    containerURLPrefix: "https://functions.prod.internal.glideapps.com",
    apiURLPrefix: () => prodApiURL,
    honeycombDatasetName: "glide-prod",
    alwaysLogReloadCauses: false,
    useProductionTemplateIDs: true,
    hubspotAccountID: "19936848",
    msalAuth: {
        tenant: "common",
        clientID: "65f4b7a7-3d3f-4dce-8da5-dbf2c2680d52",
        scope: "openid profile User.Read Files.ReadWrite offline_access",
        redirectURL: "https://go.glideapps.com/connectMicrosoft",
    },
    isDevelopment: false,
    builderDbrScannerHandshake: "100656165-100657582",
};

const stagingApiURL = "https://api.staging.glideapp.io";

const stagingSettings: LocationSettingsWithURL = {
    measurementID: stagingBuilderMeasurementID,
    firebaseConfig: FirebaseStagingConfigGlide,
    serviceWorkerLocation: "/sw-dev-v2.js",
    showBetaWarning: true,
    shortnameSuffix: ".staging.glideapp.io",
    urlPrefix: "https://staging.heyglide.com/",
    stripClientKey: "pk_test_aOhgsKuDpbZzBgt7QVRJQFOQ",
    googleCredentials: stagingCredentials,
    oAuthCallbackURL: "https://staging.heyglide.com/signInWith/google",
    fcmKey: "BNeClIVAKrrebU5YyPX46RqRD2v3WEBBx0T8X1WglQ05GQV8Baqru-iofCYV5aBac1vt5Ud6hwJflocb55xl6uU",
    cloudURLPrefix: getCloudFunctionLocationForProject("glide-staging"),
    containerURLPrefix: "https://functions.staging.internal.glideapps.com",
    apiURLPrefix: () => stagingApiURL,
    honeycombDatasetName: "glide-staging",
    alwaysLogReloadCauses: true,
    useProductionTemplateIDs: false,
    hubspotAccountID: "20075072",
    msalAuth: {
        tenant: "common",
        clientID: "b13035c3-9b26-4b62-b6d4-9c464f1fe15b",
        scope: "openid profile User.Read Files.ReadWrite offline_access",
        redirectURL: "https://staging.heyglide.com/connectMicrosoft",
    },
    isDevelopment: false,
    builderDbrScannerHandshake: "100656165-100657582",
};

export function firebaseConfigFor(loc: "staging" | "prod") {
    return loc === "staging" ? FirebaseStagingConfigGlide : FirebaseConfigGlide;
}

const devApiURL = "/api/";

const devSettings: LocationSettingsWithURL = {
    ...stagingSettings,
    firebaseConfig: {
        ...stagingSettings.firebaseConfig,
        databaseURL: "http://localhost:8080",
    },
    showBetaWarning: false,
    urlPrefix: "http://localhost:3000/",
    // As weird as this looks, it's correct: we need to go through Staging
    // proper even when developing.
    // This is due to how the Google OAuth2 Code Flow requires the redirectURL
    // to match _exactly_, or else you land yourself an invalid_grant.
    //
    // This doesn't actually improve security. Attackers definitely know our
    // redirectURL. But we don't! Thanks, Cloud.
    oAuthCallbackURL: "https://staging.heyglide.com/signInWith/google",
    cloudURLPrefix: getCloudFunctionLocationForProject("glide-staging", true),
    containerURLPrefix: "http://localhost:5056",
    apiURLPrefix: () => devApiURL,
    msalAuth: {
        ...stagingSettings.msalAuth,
        redirectURL: "http://localhost:3000/connectMicrosoft",
    },
    isDevelopment: true,
};
const sandboxSettings: LocationSettingsWithURL = {
    ...stagingSettings,
    firebaseConfig: {
        ...stagingSettings.firebaseConfig,
        apiKey: "AIzaSyDVVV-9PpwgHl7qztrWgs8DrOmqf7itExY",
        authDomain: "glide-sandbox-301022.firebaseapp.com",
        projectId: "glide-sandbox-301022",
        databaseURL: "https://glide-sandbox-301022.firebaseio.com",
        storageBucket: "glide-sandbox-301022.appspot.com",
    },
    showBetaWarning: false,
    shortnameSuffix: "glide-sandbox-301022.firebaseapp.com", // TODO this doesn't actually work
    urlPrefix: "https://glide-sandbox-301022.firebaseapp.com/",
    containerURLPrefix: "https://functions.sandbox.internal.glideapps.com",
    apiURLPrefix: () => "https://functions.sandbox.internal.glideapps.com", // there is no fly on sandbox, so no api url. just use container url directly.
    googleCredentials: {
        appId: "515782381978",
        developerKey: "AIzaSyDVVV-9PpwgHl7qztrWgs8DrOmqf7itExY",
        clientId: "515782381978-6uph475unpbnanaaiffcsfiarmhmjfg6.apps.googleusercontent.com",
        discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
    },
    oAuthCallbackURL: "https://glide-sandbox-301022.firebaseapp.com/signInWith/google",
    cloudURLPrefix: getCloudFunctionLocationForProject("glide-sandbox-301022"),
};

function emptyExceptIfPlayRoute(hostname: string, alt: string) {
    return isCustomDomain(hostname) ? "" : alt;
}

const productionPlayerSettings: LocationSettingsWithURL = {
    ...productionSettings,
    apiURLPrefix: hostname => emptyExceptIfPlayRoute(hostname, prodApiURL), // Use relative path instead
    firebaseConfig: {
        ...productionSettings.firebaseConfig,
        ...prodAnalyticsMixin,
    },
};

const productionPagesSettings: LocationSettingsWithURL = {
    ...productionSettings,
    shortnameSuffix: ".glide.page",
};

const productionPagesPlayerSettings: LocationSettingsWithURL = {
    ...productionPlayerSettings,
    shortnameSuffix: ".glide.page",
};

const stagingPagesSettings: LocationSettingsWithURL = {
    ...stagingSettings,
    shortnameSuffix: ".staging.glide.page",
};

const stagingPlayerSettings: LocationSettingsWithURL = {
    ...stagingSettings,
    apiURLPrefix: hostname => emptyExceptIfPlayRoute(hostname, stagingApiURL), // Use relative path instead
    firebaseConfig: {
        ...stagingSettings.firebaseConfig,
        ...stagingAnalyticsMixin,
    },
};

const stagingPagesPlayerSettings: LocationSettingsWithURL = {
    ...stagingPlayerSettings,
    shortnameSuffix: ".staging.glide.page",
};

const devPagesSettings: LocationSettingsWithURL = {
    ...devSettings,
    shortnameSuffix: ".staging.glide.page",
};

const devPlayerSettings: LocationSettingsWithURL = {
    ...devSettings,
    // This is intentionally empty to empty to allow for debugging
    apiURLPrefix: hostname => emptyExceptIfPlayRoute(hostname, ""), // Use relative path instead
    firebaseConfig: {
        ...devSettings.firebaseConfig,
        ...stagingAnalyticsMixin,
    },
};

const devPagesPlayerSettings: LocationSettingsWithURL = {
    ...devPlayerSettings,
    shortnameSuffix: ".staging.glide.page",
};

const sandboxPlayerSettings: LocationSettingsWithURL = {
    ...sandboxSettings,
    apiURLPrefix: hostname => emptyExceptIfPlayRoute(hostname, stagingApiURL), // Use relative path instead
    firebaseConfig: {
        ...sandboxSettings.firebaseConfig,
        ...stagingAnalyticsMixin,
    },
};

// This can be used by io-ts to construct a type equivalent to Location:
//   t.keyof(locationTypeMap)
export const locationTypeMap = {
    staging: null,
    production: null,
    dev: null,
    sandbox: null,
};

export type Location = keyof typeof locationTypeMap;

export function getLocationSettingsUnsafe<T extends AppKind | undefined>(
    location: Location,
    isPlayer: boolean,
    appKind: T
): T extends AppKind ? LocationSettingsWithURL : LocationSettings {
    if (location === "production") {
        if (appKind !== AppKind.Page) {
            return isPlayer ? productionPlayerSettings : productionSettings;
        } else {
            return isPlayer ? productionPagesPlayerSettings : productionPagesSettings;
        }
    } else if (location === "staging") {
        if (appKind !== AppKind.Page) {
            return isPlayer ? stagingPlayerSettings : stagingSettings;
        } else {
            return isPlayer ? stagingPagesPlayerSettings : stagingPagesSettings;
        }
    } else if (location === "sandbox") {
        return isPlayer ? sandboxPlayerSettings : sandboxSettings;
    } else {
        if (appKind !== AppKind.Page) {
            return isPlayer ? devPlayerSettings : devSettings;
        } else {
            return isPlayer ? devPagesPlayerSettings : devPagesSettings;
        }
    }
}

export function getAllShortnameEndings(): string[] {
    return new Array(
        ...new Set([
            productionSettings.shortnameSuffix,
            productionPlayerSettings.shortnameSuffix,
            productionPagesPlayerSettings.shortnameSuffix,
            productionPagesSettings.shortnameSuffix,
            stagingSettings.shortnameSuffix,
            stagingPlayerSettings.shortnameSuffix,
            stagingPagesPlayerSettings.shortnameSuffix,
            stagingPagesSettings.shortnameSuffix,
        ])
    );
}
